import cursor from './_components/cursor';
import tilt from './_components/tilt';
import warpStreak from './_components/warpStreak';
import topPage from './_pages/top';
import lenisScroll from './_components/lenisScroll';
import parallax from './_components/parallax';
import preloader from './_components/preloader';
import shutter from './_components/shutter';
// import loading from './_components/loading';
import splide from './_components/splide';
import animate from './_components/animate';
import lazy from './_components/lazy';
import smoothScroll from './_components/smoothScroll';
import visual from './_components/visual';
import counter from './_components/counter';
import beamShoot from './_components/beamShoot';

gsap.registerPlugin(ScrollTrigger);

splide.init();
lazy.init();
smoothScroll.init();
cursor.init();
lenisScroll.init();
shutter.init();
preloader.init();
// loading.init();
animate.init();
counter.init();
parallax.init();
tilt.init();
warpStreak.init();
beamShoot.init();

// トップページ専用（セクションが存在しない場合は内部でスキップされる）
topPage.init();

// プレローダーは 1 回だけ。完了後にビジュアル開始
(async () => {
  try {
    await preloader.init({ timeoutMs: 5000 });
  } catch (e) {
    console.error(e);
  }
  visual.start();
})();
